import { createFileRoute } from '@tanstack/react-router';
import { RestaurantList } from '@/features/restaurants/RestaurantList';

export const Route = createFileRoute('/a/restaurants')({
  staticData: {
    breadcrumbs: [{ label: 'Restaurants' }],
  },
  component: RestaurantListPage,
});

function RestaurantListPage() {
  return <RestaurantList />;
}
